'use strict'
module.exports = require('./lib')(require('./lib/elliptic'))



//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/Prod_web-client/node_modules/secp256k1/elliptic.js
// module id = NPHv
// module chunks = 15